import { CalendarOutlined, CopyOutlined } from '@ant-design/icons';
import { Button, DatePicker, Divider, Form, message, Modal, Select, Space, Tag } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { copyCommodityRate } from '../../../RestServices/postingService';
import { useSelector } from 'react-redux';
import { itemProducts } from '../../../shared';

const {Option} = Select
const RateCopyModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [selectedDates, setSelectedDates] = useState([]);

  const {  token } = useSelector((state) => state.Authentication.user);
  const { provinces,  } = useSelector((state) => state.Cities);

  const [product, setProduct] = useState("");
  
  const [province, setProvince] = useState('')
  


  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    form.resetFields();
    setSelectedDates([]);
  };

  const handleDateSelect = (date, dateString) => {
    if (date && dateString) {
      // Check if date already exists
      if (!selectedDates.some(d => d === dateString)) {
        setSelectedDates([...selectedDates, dateString]);
      }
    }
  };

  const handleRemoveDate = (dateToRemove) => {
    setSelectedDates(selectedDates.filter(date => date !== dateToRemove));
  };

  const handleSubmit = () => {
    form.validateFields().then(async values => {
      if (selectedDates.length === 0) {
        message.warning('Please select at least one destination date');
        return;
      }

      const submissionData = {
        sourceDate: values.sourceDate.format('YYYY-MM-DD'),
        destinationDates: selectedDates,
        product,
        province

      };

      console.log('Submission Data:', submissionData);
      
      await copyCommodityRate(submissionData,token)
      // Here you would make your API call to copy the rates
      message.success(`Rates will be copied from ${submissionData.sourceDate} to ${selectedDates.length} selected date(s)`);
      
      handleCloseModal();
    }).catch(error => {
      console.error('Validation failed:', error);
    });
  };

  // Disable dates that are already selected
  const disabledDate = (current) => {
    if (!current) return false;
    const dateString = current.format('YYYY-MM-DD');
    return selectedDates.includes(dateString);
  };

  return (
    <div >
      {/* Main Button */}
      <Button
        type="primary"
        icon={<CopyOutlined />}
        onClick={handleOpenModal}
        size="large"
        className="responsive-btn"
      >
        Copy Rates to Multiple Dates
      </Button>

      {/* Modal */}
     {isModalOpen? <Modal
        title={
          <Space>
            <CopyOutlined />
            <span>Copy Rates</span>
          </Space>
        }
        visible={true}
        onCancel={handleCloseModal}
        width={700}
        footer={[
          <Button key="cancel" onClick={handleCloseModal}>
            Cancel
          </Button>,
          <Button 
            key="submit" 
            type="primary" 
            icon={<CopyOutlined />}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
        >
        

          {/* Source Date Selection */}
          <Form.Item
            name="sourceDate"
            label={
              <Space>
                <CalendarOutlined />
                <span>Select Source Date (Copy rates from this date)</span>
              </Space>
            }
            rules={[{ required: true, message: 'Please select a source date' }]}
          >
            <DatePicker 
              size="large"
              style={{ width: '100%' }}
              format="YYYY-MM-DD"
              placeholder="Select source date"
            />
          </Form.Item>


          {/* Destination Dates Selection */}
          <Form.Item
            label={
              <Space>
                <CalendarOutlined />
                <span>Select Destination Dates (Copy rates to these dates)</span>
              </Space>
            }
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              <DatePicker
                size="large"
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
                placeholder="Click to add destination dates"
                value={null}
                onChange={handleDateSelect}
                disabledDate={disabledDate}
              />
              
              {selectedDates.length > 0 && (
                <div style={{ 
                  marginTop: '16px',
                  padding: '12px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  backgroundColor: '#fafafa'
                }}>
                  <div style={{ marginBottom: '8px', fontWeight: 500 }}>
                    Selected Dates ({selectedDates.length}):
                  </div>
                  <Space wrap>
                    {selectedDates.map(date => (
                      <Tag
                        key={date}
                        closable
                        onClose={() => handleRemoveDate(date)}
                        color="blue"
                      >
                        {moment(date).format('MMM DD, YYYY')}
                      </Tag>
                    ))}
                  </Space>
                </div>
              )}
              
              {selectedDates.length === 0 && (
                <div style={{ 
                  color: '#999',
                  fontStyle: 'italic',
                  marginTop: '8px'
                }}>
                  No destination dates selected yet. Use the date picker above to add dates.
                </div>
              )}
            </Space>
          </Form.Item>
          <Divider />


            {/* Province Selection */}
            <Form.Item
            name="province"
            label="Select Province"
            rules={[{ required: false, message: 'Please select a province' }]}
          >
            <Select
              placeholder="Choose a province"
              size="large"
              showSearch
              value={province}
              onChange={({value})=>setProvince(value)}
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {provinces.map(province => (
                <Option key={province} value={province} label={province}>
                  {province}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="Category"
            label="Select Category"
            rules={[{ required: false, message: 'Please select a category' }]}
          >
            <Select
              placeholder="Choose a category"
              size="large"
              value={product}
              onChange={({value})=>setProduct(value)}
              showSearch
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {itemProducts.map(category => (
                <Option key={category} value={category} label={category}>
                  {category}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>:<></>}
    </div>
  );
};

export default RateCopyModal;